<template>
  <div class="product-list">
    <h2>Product List</h2>
    <button @click="navigateToCreatePage" class="create-button">Create New Product</button>

    <table>
      <thead>
      <tr>
        <th>Title</th>
        <th>Type</th>
        <th>Status</th>
        <th>Subcategory</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="product in products" :key="product.id">
        <td><a :href="`/product/${product.slug}`">{{ product.title }}</a></td>
        <td>{{ product.type }}</td>
        <td>{{ product.status }}</td>
        <td>{{ product.subcategory ? product.subcategory.category.title+ "->"+ product.subcategory.name : "N/A" }}</td>
        <td>
          <button @click="navigateToUpdatePage(product.id)" class="update-button">Update</button>
          <button @click="deleteProduct(product.id)" class="delete-button">Delete</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import {ref, onMounted} from "vue";
import {useRouter} from "vue-router";

export default {
  name: "ProductListView",
  setup() {
    const products = ref([]);
    const router = useRouter();

    // Fetch products when component is mounted
    const fetchProducts = () => {
      axios
          .get("/dashboard/products/")
          .then((response) => {
            products.value = response.data;
          })
          .catch((error) => {
            console.error("Error fetching products:", error);
          });
    };

    onMounted(fetchProducts);

    // Navigate to product creation page
    const navigateToCreatePage = () => {
      router.push({name: "ProductCreate"}); // Ensure your route name matches
    };

    // Navigate to product update page
    const navigateToUpdatePage = (productId) => {
      router.push({name: "ProductUpdate", params: {productId: productId}}); // Ensure your route name and params match
    };

    // Delete a product
    const deleteProduct = (productId) => {
      if (confirm("Are you sure you want to delete this product?")) {
        axios
            .delete(`/dashboard/products/${productId}/`)
            .then(() => {
              products.value = products.value.filter((product) => product.id !== productId);
              alert("Product deleted successfully!");
            })
            .catch((error) => {
              console.error("Error deleting product:", error);
              alert("There was an error deleting the product.");
            });
      }
    };

    return {
      products,
      navigateToCreatePage,
      navigateToUpdatePage,
      deleteProduct,
    };
  },
};
</script>

<style scoped>
.product-list {
  max-width: 800px;
  margin: 0 auto;
}

.create-button {
  margin-bottom: 20px;
  padding: 10px 15px;
  background-color: #4caf50;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

.create-button:hover {
  background-color: #45a049;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: #f2f2f2;
}

th, td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}

.update-button, .delete-button {
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  margin-right: 5px;
}

.update-button {
  background-color: #2196f3;
  color: white;
}

.update-button:hover {
  background-color: #0b7dda;
}

.delete-button {
  background-color: #f44336;
  color: white;
}

.delete-button:hover {
  background-color: #da190b;
}
</style>
